import { managerFactory } from "@/factories/manager";
import { initializeLoggerClient } from "@/managers/logging-client/initializeLoggerClient";

export const loggerClientManager = managerFactory.create({
  initializer: initializeLoggerClient,
});
